import { Field } from 'Util/Query';

export class DiamondQuery {
    getQuery(pageSize, currentPage, filter, caratvalue, pricevalue, depthvalue, tablevalue, degree_view_360) {
        const query = new Field('getDiamondsByFilter')
            .addArgument('pageSize', 'Int!', pageSize)
            .addArgument('currentPage', 'Int!', currentPage)
            .addArgument('filter', 'DiamondFilterInput', filter)
            .addFieldList(this._getDiamondProduct());

        if (caratvalue?.min_carat && caratvalue?.max_carat) {
            query.addArgument('carat', 'caratRangeInput', caratvalue);
        }

        if (pricevalue?.min_price && pricevalue?.max_price) {
            query.addArgument('price', 'PriceRangeInput', pricevalue)
        }

        if (depthvalue?.min_depth && depthvalue?.max_depth) {
            query.addArgument('depth', 'depthRangeInput', depthvalue);
        }

        if (tablevalue?.min_table_percent && tablevalue?.max_table_percent) {
            query.addArgument('table', 'tableRangeInput', tablevalue);
        }

        if (degree_view_360) {
            query.addArgument('degree_view_360', 'Boolean', degree_view_360);
        }

        return query;
    }

    _getDiamondProduct() {
        return [
            'total_pages',
            'total_items',
            this._getDiamondField()
        ];
    }

    _getDiamondField() {
        return new Field('product')
            .addFieldList(this._getDiamondFields());
    }

    _getDiamondFields() {
        return [
            'diamond_sku',
            // 'diamond_type',
            'diamond_price',
            'diamond_shape',
            'diamond_carat',
            'diamond_color',
            'diamond_clarity',
            'diamond_culet',
            'diamond_fluorescence',
            'diamond_depth',
            'diamond_table_percent',
            'diamond_polish',
            'diamond_symmetry',
            'diamond_depth_enable',
            // 'diamond_table_enable',
            // 'diamond_polish_enable',
            // 'diamond_symmetry_enable',
            // 'diamond_girdle_percent',
            'diamond_measurement',
            'diamond_cut',
            'diamond_certificate',
            'diamond_ratio',
            // 'diamond_certificate_number',
            'stock_num',
            'video_url',
            'cert_url',
            // 'image_thumb_url',
            'image_url',
            // 'price_per_carat',   
            // 'size',
            // 'diamond_ratio',
            // 'estimated_delivery',
            // 'diamond_length',
            'girdle_max',
            'girdle_min',
            // 'dia_gem_shape',
            'diamond_created_from',
            // 'color_diamond',
            // 'intensity',
            // 'color_diamond_created_from',
            // 'fancy_color_dominant_color',
            // 'fancy_color_intensity',
            // 'diamond_import_type',
            // 'diamond_import_type',
        ];
    }

    getDiamond(sku) {
        return new Field('getDiamondsBySku')
            .addArgument('sku', 'String!', sku)
            .addFieldList(this._getDiamondProductBySku())
    }

    _getDiamondProductBySku() {
        return [
            this._getSkuDiamondField()
        ]
    }

    _getSkuDiamondField() {
        return new Field('product')
            .addFieldList(this._getDiamondSkuFields());
    }

    _getDiamondSkuFields() {
        return [
            'diamond_sku',
            'hasColor',
            'diamond_ratio',
            'diamond_price',
            'diamond_shape',
            'diamond_carat',
            'diamond_color',
            'diamond_clarity',
            'diamond_culet',
            'diamond_fluorescence',
            'diamond_depth',
            'diamond_table_percent',
            'diamond_polish',
            'diamond_symmetry',
            'diamond_depth_enable',
            'diamond_measurement',
            'diamond_cut',
            'diamond_certificate',
            'stock_num',
            'video_url',
            'cert_url',
            'image_url',
            'girdle_max',
            'girdle_min',
            'diamond_created_from',
        ];
    }
}

export default new DiamondQuery();
